import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=2c6e85c6&scoped=true&lang=html&"
import script from "./complete.vue?vue&type=script&lang=js&"
export * from "./complete.vue?vue&type=script&lang=js&"
import style0 from "./complete.vue?vue&type=style&index=0&id=2c6e85c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e85c6",
  null
  
)

export default component.exports